// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// The design binding's own step-count glyph — three ruled lines, the shortest
// one shorter — not a document/receipt icon. Carbon's icon set has nothing that
// draws this shape, so it's the binding's inline SVG verbatim rather than the
// nearest Carbon substitute:
//   <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor"
//        stroke-width="1.4"><path d="M3 4h10M3 8h10M3 12h7" stroke-linecap="round"/></svg>

import React from 'react';

export default function StepCountIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <path d="M3 4h10M3 8h10M3 12h7" strokeLinecap="round" />
    </svg>
  );
}
